module.exports = __webpack_public_path__ + "static/media/murphys.266f6565.png";